import React from 'react';
import { Criteria } from '../../../models';

interface MetricCriteriaProps {
  criteria: Criteria;
  active: boolean;
}

function MetricCriteria({ criteria, active }: MetricCriteriaProps) {
  return (
    <div
      key={criteria._id}
      className={`w-full  rounded my-2 mx-2 flex flex-col items-center  p-2 ${
        active ? 'shadow-lg border border-purple-100' : 'shadow-sm'
      } `}
    >
      <span>
        <span className="  text-gray-300 ">Rango: </span>
        <span className="text-neutral-400 ">
          {`${
            criteria.lowerRange === criteria.upperRange &&
            criteria.lowerRange === 100
              ? `+${criteria.lowerRange}%`
              : `${criteria.lowerRange}% - ${criteria.upperRange}%`
          }`}
        </span>
      </span>
      <span>
        <span className="  text-purple-200  ">Recompensa: </span>
        <span className="text-neutral-400 ">{criteria.reward} Puntos</span>
      </span>
    </div>
  );
}

export default MetricCriteria;
